import { render, staticRenderFns } from "./recordTopsearch.vue?vue&type=template&id=16ce8e34&scoped=true"
import script from "./recordTopsearch.vue?vue&type=script&lang=js"
export * from "./recordTopsearch.vue?vue&type=script&lang=js"
import style0 from "./recordTopsearch.vue?vue&type=style&index=0&id=16ce8e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ce8e34",
  null
  
)

export default component.exports